import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { HttpHeaders } from '@angular/common/http';
import { ApiService } from '../../../services/api.service';
import { TEMPLATE_WHATSAPP_MEDIA } from "../../../../config";
import { environment } from '../../../../../environments/environment';

@Component({
  selector: 'app-error-preview',
  templateUrl: `./error-preview.component.html`,
  styles: []
})
export class ErrorPreviewComponent implements OnInit {

  renderColorSpan1: string = '';
  renderColorSpan2: string = '';
  rendervalue;
  @Input() value: any = [];
  @Input() rowData: any;
  @Output() previewClick: EventEmitter<any> = new EventEmitter();
  data = '';

  constructor(private apiService: ApiService) {

  }

  ngOnInit() {
    if (this.rowData.status == 5) {
      this.renderColorSpan1 = 'dots-bgcolor-red';
      this.renderColorSpan2 = 'dots-color-red';
    }
  }

  onPreviewClick() {
    this.previewClick.emit(this.rowData);
    this.data = this.rowData['content'];
  }

  downloadMedia(attachmentId, ctype, name) {
    let targetUrl = `${environment.whatspp_api_url}${TEMPLATE_WHATSAPP_MEDIA}`;
    window.open(targetUrl + attachmentId + '?ctype=' + ctype + '&name=' + name);
    return false;
  }
}
